export enum SlhNavigationListPosition {
  RIGHT = "right",
  BOTTOM = "bottom",
}
